import { ContentType, isProductUpdate, isArticle, isDiscussion, isQuestion } from '../../utils/contentType'
import { Component, h } from 'preact'
import htmlParser from '../../utils/htmlParser'
import { excerpt } from '../../utils/string'
import { pascalToKebab } from '../../utils/toKebabCase'

type Props = {
  topicId: string;
  contentType: ContentType;
  title: string;
  content: string;
  replyId: string;
}

type State = {
  showMore: boolean;
}

class SpamPostCell extends Component<Props, State> {
  state = {
    showMore: false
  }

  render ({ topicId, contentType, title, content, replyId } : Props, { showMore } : State) {
    const strippedContent = htmlParser.stripHtml(content) || ''
    const excerptLimit = 200 // characters

    const urlContentType = isProductUpdate(contentType) ? pascalToKebab(contentType) :`${contentType}s`;

    const titleUrl = (replyId && (isArticle(contentType) || isQuestion(contentType) || isDiscussion(contentType))) ? `/${urlContentType}/${topicId}/replies/${replyId}` : `/${urlContentType}/${topicId}`

    return <div class='overview__spam-post'>
      <a class='bold' href={titleUrl}>{ replyId && 'RE: '}{ title }</a>
      <div class='overview__spam-post-content'>
        <span>{ showMore ? strippedContent : excerpt(strippedContent, excerptLimit) }</span>
        { strippedContent.length > excerptLimit && <a onClick={() => this.setState({ showMore: !showMore })}>Show {showMore ? 'less' : 'more'}</a>}
      </div>
    </div>
  }
}

export default SpamPostCell
